import React, {useCallback} from "react";
import {Link, useHistory} from "react-router-dom";

const TripHeader = (props) => {
  let {
    aircraftName,
    clientInfo,
    clientName,
    createdDateFormatted,
    earliestDepartureDateFormatted,
    ownerName,
    tripTag,
  } = props.data;

  const history = useHistory();

  const handleGoBack = useCallback(() => {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push("/trips");
    }
  }, [history]);

  return (
    <div id="page-header" className="trip-header">
      <div className="back-button-container">
        <div onClick={handleGoBack} className="back-button base-button icon-button evo-blue mr-10">
          <span className="material-icons">chevron_left</span>
        </div>
      </div>

      <div id="page-title-container">
        <p className="owner-name">{ownerName}</p>
        <p className="created-on">Created on {createdDateFormatted}</p>
        <h1 className="page-title">
          {clientName} | Trip #{tripTag}&nbsp;

          {clientInfo && (<span>
            <Link className="text-transform-none" to={`/prospects/${clientInfo._id}`} target="_blank" rel="noopener noreferrer">
              (view prospect)
            </Link>
          </span>)}

          <br/>

          <span>
            Departing {earliestDepartureDateFormatted} - {aircraftName}
          </span>
        </h1>
      </div>

      <div id="page-breadcrumb">
        <ol className="breadcrumb">
          {props.breadcrumbs.map((item) => {
            return (
              <li className="breadcrumb-item" key={item.label}>
                <Link to={item.link}>{item.label}</Link>
              </li>
            );
          })}
          <span className="material-icons">chevron_right</span>
          <li className="breadcrumb-item active">Trip #{tripTag}</li>
        </ol>
      </div>
    </div>
  );
};

export default TripHeader;
